import { trackEvent } from '@Services/analytics/tracking.service.ts';

export const useAddOwnerAnalytics = () => {
  function reportActOnAddOwner(isGrantAccessToOwner: boolean): void {
    trackEvent('Act on Add Owner', { grant_access_to_owner: isGrantAccessToOwner });
  }
  function reportSetUBO(
    ownershipPercentage: number,
    onlyUBO: boolean,
    numberOfOwners: number
  ): void {
    trackEvent('Set UBO', {
      OwnershipPercentage: ownershipPercentage,
      Only_ubo: onlyUBO,
      number_Owners: numberOfOwners,
    });
  }
  return { reportActOnAddOwner, reportSetUBO };
};
